import { useState } from "react";

import { loadVendorQuotationItemDetail } from "../services/vendorEnquiryService";

const useLoadVendorQuotationDetailByVendor = () => {
    const [VendorQuotationDetails, setVendorQuotationDetails] = useState([]);

    // Fetch department data
    const fetchVendorDetail = async (selectedID = null, idresponsehdr = null) => {
        const para = {
            p_companyid: localStorage.getItem("companyid"),
            p_plantid: 1,
            p_id_enquiry: selectedID,
            p_id_response_hdr: idresponsehdr
        };

        try {
            const data = await loadVendorQuotationItemDetail(para);
            if (data && data.length > 0) {
                setVendorQuotationDetails(data);
                return data;
            }
            else
            {
                return [];
            }
        } catch (error) {
            // CallMessage("error", error.message, "Error");
        }
    };

    // Function to load department based on selected ID
    const loadVendorDetailByVendorID = async (selectedID, idresponsehdr) => {
        return await fetchVendorDetail(selectedID, idresponsehdr);
    };

    return {
        VendorQuotationDetails,
        setVendorQuotationDetails,
        loadVendorDetailByVendorID,
    };
};

export default useLoadVendorQuotationDetailByVendor;
